import React from "react";
import { DataList } from "@redriver/cinnamon";
import { ThumbnailTile } from "components/containers";

const GroupSection = ({ group, Id, onRefresh, typeActions, ...props }) => {
  const imageItems = (group.items || []).filter((i) => !!i.imageUrl);
  const imageArray = imageItems.map((i) => i.imageUrl);
  return (
    <div>
      <h4>{group.documentType}</h4>
      <DataList>
        {(group.items || []).map((document) => (
          <DataList.Item key={document.id || document.fileName}>
            <ThumbnailTile
              document={document}
              typeActions={typeActions}
              imageArray={imageArray}
              imageIndex={imageItems.findIndex(
                (i) => i.blobId === document.blobId,
              )}
              {...props}
            />
          </DataList.Item>
        ))}
      </DataList>
    </div>
  );
};

export default GroupSection;
